import { addDoc, collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { db } from "../../../firebase";
import { STUDIO_CONNECTION_AUDIT_COLLECTION } from "../constants";

export async function logConnectionAudit({
  action,
  connectionId,
  connectionName,
  projectId,
  adminUid,
  adminName,
  details = {},
}) {
  await addDoc(collection(db, STUDIO_CONNECTION_AUDIT_COLLECTION), {
    action,
    connectionId: connectionId || null,
    connectionName: connectionName || "",
    projectId: projectId || "",
    adminUid: adminUid || "",
    adminName: adminName || "",
    details,
    dateTime: new Date().toISOString(),
    device: typeof navigator !== "undefined" ? navigator.userAgent : "",
  });
}

export async function fetchConnectionAuditLogs({ connectionId, projectId, max = 50 } = {}) {
  const snap = await getDocs(
    query(collection(db, STUDIO_CONNECTION_AUDIT_COLLECTION), orderBy("dateTime", "desc"), limit(max))
  );
  let rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  if (connectionId) rows = rows.filter((r) => r.connectionId === connectionId);
  if (projectId) rows = rows.filter((r) => r.projectId === projectId);
  return rows;
}
